import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {useHistory} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {getShippingCosts} from '@/api/shippingCosts';
import {now} from '@/lib/utils/date';

import {Formik, Field, FormikProps, FormikValues, FieldProps} from 'formik';

import {
  Input,
  Label,
  Dropdown,
  Checkbox,
  SemanticTextArea,
} from '@/components/Form';
import {Button} from 'semantic-ui-react';

import {Modal} from '@/components/';

import Dropzone from './Dropzone';
import {
  fishingSpots,
  shippingExpenses,
  deliveryMethods,
  shippingTimings,
  shippingSizes,
  areas,
  closeBidMins,
  years,
  featureYears,
  months,
  days,
  // 追加
  sizes,
  grades,
  harvestTiming,
  saveMethod,
  cultivationMethod,
  soil,
  pesticides,
  genetic,
  jas,
  soilAdditionalInfo,
  pesticidesAdditionalInfo,
} from '@/config/constants/options';

import {submit} from './handlers';
import {initialState} from './initialState';
import {create} from '@/lib/validations/stocks';
import utils from '@/lib/utils';
import './index.scss';

const env = utils.env.get();

export const StocksCreate: React.FC = () => {
  const [cost, setCost] = useState({id: 0, userId: 0});
  const [isModal, setModal] = useState(false);
  const history = useHistory();
  const {id, isCompany, shippingProvider} = useSelector((state) => state.me);

  useEffect(() => {
    const fetch = async (id: number) => {
      try {
        const {data}: {data: any} = await getShippingCosts(id);

        setCost({
          id: data.id,
          userId: data.user_id,
        });
      } catch (error: any) {
        console.error(error);
      }
    };

    fetch(id);
  }, [id]);

  return (
    <div className="a__stocks__create">
      <div className="b__caption">
        <h2>在庫登録</h2>
      </div>
      <Formik
        initialValues={initialState}
        validate={create}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (value, actions) => {
          await submit(
            {sellerUserId: id, ...value},
            actions,
            history,
            setModal
          );
        }}
      >
        {(formProps: FormikProps<FormikValues>) => (
          <form className="form">
            <div className="form__main">
              <Dropzone name="imageJson" />
              <div className="b__field">
                <Label text="商品名 (最大50文字)" required />
                <Field
                  name="name"
                  component={Input.Default}
                  maxLength="50"
                  placeholder=""
                />
                {formProps.errors['name'] !== undefined ? (
                  <a className="form__error">{formProps.errors['name']}</a>
                ) : null}
              </div>

              {/* 追加 */}
              <div className="b__field">
                <Label text="品種名 (最大50文字)" required />
                <Field
                  name="breed"
                  component={Input.Default}
                  maxLength="50"
                  placeholder="例）りんご"
                />
                {formProps.errors['breed'] !== undefined ? (
                  <a className="form__error">{formProps.errors['breed']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="サイズ（JA規格）" optional />
                <Field
                  name="size"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...sizes,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['size'] !== undefined ? (
                  <a className="form__error">{formProps.errors['size']}</a>
                ) : null}
              </div>

              <div className="b__field__m0">
                <Field
                  name="isUnevenness"
                  label="不揃い"
                  component={Checkbox}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.checked);
                  }}
                />
              </div>

              <div className="b__field">
                <Label text="重量 (最大10,000,000g)" optional />
                <Field
                  name="weight"
                  component={Input.Default}
                  maxLength="8"
                  placeholder="例) 1500"
                  label={{basic: true, content: 'g'}}
                  labelPosition="right"
                />
                {formProps.errors['weight'] !== undefined ? (
                  <a className="form__error">{formProps.errors['weight']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Field
                  name="weightAdditionalInfo"
                  component={Input.Default}
                  maxLength="50"
                  placeholder="備考"
                />
                <div className="b__paragraph">(最大50文字)</div>
              </div>

              <div className="b__field">
                <Label text="生産者 (最大50文字)" optional />
                <Field
                  name="producer"
                  component={Input.Default}
                  maxLength="50"
                  placeholder="山田さん"
                />
                {formProps.errors['producer'] !== undefined ? (
                  <a className="form__error">{formProps.errors['producer']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="等級" optional />
                <Field
                  name="grade"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...grades,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['grade'] !== undefined ? (
                  <a className="form__error">{formProps.errors['grade']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="産地" optional />
                <Field
                  name="origin"
                  component={Dropdown}
                  fluid
                  options={fishingSpots}
                  selection
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                  placeholder="選択してください"
                />
              </div>

              <div className="b__field">
                <Field
                  name="originAdditionalInfo"
                  component={Input.Default}
                  maxLength="50"
                  placeholder="詳細ポイント"
                />
              </div>

              <div className="b__field">
                <Label text="平均糖度" optional />
                <Field
                  name="averageSugarContent"
                  component={Input.Default}
                  maxLength="5"
                  placeholder="例）10.0"
                  label={{basic: true, content: '%'}}
                  labelPosition="right"
                />
                {formProps.errors['average_sugar_content'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['average_sugar_content']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="収穫日" optional />
                <div className="b__field__row">
                  <div className="b__field__column">
                    <Field
                      name="fishingDate.year"
                      component={Dropdown}
                      fluid
                      selection
                      placeholder={now('YYYY')}
                      options={years}
                      onChange={(_: any, field: any) => {
                        formProps.setFieldValue(field.name, field.value);
                      }}
                    />
                    <span>年</span>
                  </div>
                  <div className="b__field__column">
                    <Field
                      name="fishingDate.month"
                      component={Dropdown}
                      fluid
                      selection
                      placeholder={now('M')}
                      options={months}
                      onChange={(_: any, field: any) => {
                        formProps.setFieldValue(field.name, field.value);
                      }}
                    />
                    <span>月</span>
                  </div>
                  <div className="b__field__column">
                    <Field
                      name="fishingDate.day"
                      component={Dropdown}
                      fluid
                      selection
                      placeholder={now('D')}
                      options={days}
                      onChange={(_: any, field: any) => {
                        formProps.setFieldValue(field.name, field.value);
                      }}
                    />
                    <span>日</span>
                  </div>
                </div>
              </div>

              <div className="b__field__m0">
                <Field
                  name="isLandAfterFix"
                  label="落札後収穫"
                  component={Checkbox}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.checked);
                  }}
                />
              </div>

              <div className="b__field">
                <Label text="収穫タイミング" optional />
                <Field
                  name="harvestTiming"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...harvestTiming,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['harvestTiming'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['harvestTiming']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="出品者側保管方法" />
                <Field
                  name="saveMethodSeller"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...saveMethod,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['saveMethodSeller'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['saveMethodSeller']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="ご家庭での推奨保管方法" optional />
                <Field
                  name="saveMethodUser"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...saveMethod,
                  ]}
                  selection
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                  placeholder="選択してください"
                />
              </div>

              <div className="b__field">
                <Field
                  name="saveMethodUserAdditionalInfo"
                  component={Input.Default}
                  maxLength="50"
                  placeholder="お召し上がりになる約1時間前に冷蔵庫で冷やして など"
                />
              </div>

              <div className="b__field">
                <Label text="栽培方法" optional />
                <Field
                  name="cultivationMethod"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...cultivationMethod,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['cultivation_method'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['cultivation_method']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="土壌" optional />
                <Field
                  name="soil"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...soil,
                  ]}
                  selection
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                  placeholder="選択してください"
                />
                {formProps.values['soil'] === 4 && (
                  <div className="stack">
                    {soilAdditionalInfo.map((e) => (
                      <Field
                        key={e.key}
                        name={`soilAdditionalInfo[${e.key}]`}
                        label={e.text}
                        component={Checkbox}
                        onChange={(_: any, field: any) => {
                          formProps.setFieldValue(field.name, field.checked);
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>

              <div className="b__field">
                <Label text="農薬" optional />
                <Field
                  name="pesticides"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...pesticides,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['pesticides'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['pesticides']}
                  </a>
                ) : null}
                {formProps.values['pesticides'] === 2 && (
                  <Field
                    name="pesticidesAdditionalInfo[0]"
                    component={Input.Default}
                    maxLength="50"
                    placeholder="節減対象農薬を節減「当地比〇割減、〇〇地域比○割減）」"
                  />
                )}
                {formProps.values['pesticides'] === 3 && (
                  <div className="stack">
                    {pesticidesAdditionalInfo.map((e) => (
                      <Field
                        key={e.key}
                        name={`pesticidesAdditionalInfo[${e.key}]`}
                        label={e.text}
                        component={Checkbox}
                        onChange={(_: any, field: any) => {
                          formProps.setFieldValue(field.name, field.checked);
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>

              <div className="b__field">
                <Label text="遺伝子組み換え" optional />
                <Field
                  name="genetic"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...genetic,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['genetic'] !== undefined ? (
                  <a className="form__error">{formProps.errors['genetic']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="有機JAS認定" optional />
                <Field
                  name="jas"
                  component={Dropdown}
                  fluid
                  options={[
                    {
                      key: '0',
                      value: null,
                      name: '',
                      text: '未設定',
                    },
                    ...jas,
                  ]}
                  selection
                  placeholder="選択してください"
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['jas'] !== undefined ? (
                  <a className="form__error">{formProps.errors['jas']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="個別的義務表示事項 (最大50文字)" optional />
                <Field
                  name="individualObligations"
                  component={Input.Default}
                  maxLength="50"
                  placeholder="アレルゲン、消費期限又は賞味期限、添加物など"
                />
                {formProps.errors['individual_obligations'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['individual_obligations']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="グローバルGAP" optional />
                <Field
                  name="globalGap"
                  label="認証"
                  component={Checkbox}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.checked);
                  }}
                />
                {formProps.errors['global_gap'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['global_gap']}
                  </a>
                ) : null}
              </div>
              {/* ここまで追加 */}

              <div className="b__field">
                <Label text="配送料の負担" required />
                <Field
                  name="shippingExpense"
                  component={Dropdown}
                  fluid
                  selection
                  placeholder="選択してください"
                  options={shippingExpenses.filter(
                    ({value}) =>
                      value !== 3 ||
                      (isCompany &&
                        shippingProvider !== 0 &&
                        cost.id !== 0 &&
                        cost.userId !== 0)
                  )}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['shippingExpense'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['shippingExpense']}
                  </a>
                ) : null}
              </div>

              {formProps.values.shippingExpense === 3 ? (
                <div className="b__field">
                  <Label text="配送サイズ区分" required />
                  <Field
                    name="shippingSize"
                    component={Dropdown}
                    fluid
                    placeholder="選択してください"
                    selection
                    options={shippingSizes}
                    onChange={(_: any, field: any) => {
                      formProps.setFieldValue(field.name, field.value);
                    }}
                  />
                  {formProps.errors['shippingSize'] !== undefined ? (
                    <a className="form__error">
                      {formProps.errors['shippingSize']}
                    </a>
                  ) : null}
                </div>
              ) : null}

              <div className="b__field">
                <Label text="配送方法" required />
                <Field
                  name="deliveryMethod"
                  component={Dropdown}
                  fluid
                  selection
                  placeholder="選択してください"
                  options={deliveryMethods}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['deliveryMethod'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['deliveryMethod']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="発送までの日数" required />
                <Field
                  name="shippingTiming"
                  component={Dropdown}
                  fluid
                  selection
                  placeholder="選択してください"
                  options={shippingTimings}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['shippingTiming'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['shippingTiming']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="発送元の地域" required />
                <Field
                  name="area"
                  component={Dropdown}
                  fluid
                  selection
                  placeholder="選択してください"
                  options={areas}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['area'] !== undefined ? (
                  <a className="form__error">{formProps.errors['area']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="出品時の開始価格" required />
                <Field
                  name="startPrice"
                  component={Input.Default}
                  maxLength="8"
                  placeholder="入力してください"
                  label={{basic: true, content: '¥'}}
                  labelPosition="left"
                />
                {formProps.errors['startPrice'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['startPrice']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="即決価格" optional />
                <Field
                  name="fixPrice"
                  component={Input.Default}
                  maxLength="8"
                  placeholder="入力してください"
                  label={{basic: true, content: '¥'}}
                  labelPosition="left"
                />
                {formProps.errors['fixPrice'] !== undefined ? (
                  <a className="form__error">{formProps.errors['fixPrice']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="出品期限" required />
                <Field
                  name="closeBidMin"
                  component={Dropdown}
                  fluid
                  selection
                  placeholder="選択してください"
                  options={closeBidMins}
                  onChange={(_: any, field: any) => {
                    formProps.setFieldValue(field.name, field.value);
                  }}
                />
                {formProps.errors['closeBidMin'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['closeBidMin']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="出品商品説明" required />
                <Field
                  name="explanation"
                  component={SemanticTextArea}
                  rows="5"
                  maxLength="1000"
                />
                <div className="b__paragraph">(最大1,000文字)</div>
                {formProps.errors['explanation'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['explanation']}
                  </a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="繰り返し回数" required />
                <Field
                  name="capacity"
                  component={Input.Default}
                  maxLength="2"
                  placeholder="入力してください"
                  label={{basic: true, content: '回'}}
                  labelPosition="right"
                />
                {formProps.errors['capacity'] !== undefined ? (
                  <a className="form__error">{formProps.errors['capacity']}</a>
                ) : null}
              </div>

              <div className="b__field">
                <Label text="繰り返し期限" required />
                <div className="b__field__row">
                  <div className="b__field__column">
                    <Field
                      name="repeatLimitDate.year"
                      component={Dropdown}
                      fluid
                      selection
                      options={featureYears}
                      onChange={(_: any, field: any) => {
                        formProps.setFieldValue(field.name, field.value);
                      }}
                    />
                    <span>年</span>
                  </div>
                  <div className="b__field__column">
                    <Field
                      name="repeatLimitDate.month"
                      component={Dropdown}
                      fluid
                      selection
                      options={months}
                      onChange={(_: any, field: any) => {
                        formProps.setFieldValue(field.name, field.value);
                      }}
                    />
                    <span>月</span>
                  </div>
                  <div className="b__field__column">
                    <Field
                      name="repeatLimitDate.day"
                      component={Dropdown}
                      fluid
                      selection
                      options={days}
                      onChange={(_: any, field: any) => {
                        formProps.setFieldValue(field.name, field.value);
                      }}
                    />
                    <span>日</span>
                  </div>
                </div>
                {formProps.errors['repeatLimitDate'] !== undefined ? (
                  <a className="form__error">
                    {formProps.errors['repeatLimitDate']}
                  </a>
                ) : null}
              </div>
            </div>

            <div className="b__action">
              <Button
                type="button"
                onClick={async () => {
                  const v = await formProps.validateForm();
                  if (_.isEmpty(v)) {
                    setModal(true);
                  } else {
                    if (document.getElementsByClassName('form__error')) {
                      const errors = document.getElementsByClassName(
                        'form__error'
                      ) as HTMLCollectionOf<HTMLElement>;

                      errors[0].scrollIntoView({
                        behavior: 'auto',
                        block: 'center',
                        inline: 'nearest',
                      });
                    }
                  }
                }}
              >
                登録する
              </Button>
            </div>

            <Modal.Normal
              isModal={isModal}
              handleCloseModal={() => {
                setModal(false);
              }}
              onClick={() => formProps.handleSubmit()}
              size="sm"
              loading={formProps.isSubmitting}
              submitColor="main"
              submitText="登録する"
              title="在庫に登録する"
            />
          </form>
        )}
      </Formik>
      <div>
        ※元払い出品の送料については
        <a
          href={`${env.WEB_APP_HOST}/introduction/prepayment`}
          rel="noopener noreferrer"
          target="_blank"
        >
          こちら
        </a>
        から
      </div>
    </div>
  );
};
